define.alias("shared/components/shared/social-identity/info", "media/components/shared/social-identity/info");